module.exports = __webpack_public_path__ + "static/img/question.6dd93e77.svg";